import React from 'react'
import PropTypes from 'prop-types'

import Modal from '../Modal'

const WarningModal = ({ handleCancel, handleConfirm, translate}) => (
  <Modal
    renderButton={false}
    onCloseModal={handleCancel}
    onConfirm={handleConfirm}
    size='md'
    isOpen
    center
    showHeader={false}
    cancelButtonText={translate('button.cancel')}
    confirmButtonText={translate('missionMenu.warningModal.primaryButton')}
    confirmType='danger'
    className='mission-block-edit-modal'
  >
    <h3 className='delete w-100'>
      <strong>{translate('missionMenu.warningModal.title')}</strong>
    </h3>
    <em className='w-100'>{translate('missionMenu.warningModal.text1')}</em>
    <em className='w-100'>{translate('missionMenu.warningModal.text2')}</em>
  </Modal>
)

WarningModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default WarningModal
